
export default {
    tasks: [],
    taskTags: [],
    todoSearchQuery: '',
    todoFilter: null,
};
